import {
  FIELD_BIRTH,
  FIELD_EMAIL,
  FIELD_FIRST_NAME,
  FIELD_GENDER,
  FIELD_LAST_NAME,
  FIELD_NATIONALITY,
  FIELD_PHONE,
} from '@components/dynamic-input-fields/constants';
import { FormField } from '@components/modals/add-holder-modal/add-holder-modal.type';

import { InviteGuestForm } from '../process-invite-guest.type';

const createField = (field: keyof InviteGuestForm, form: InviteGuestForm) => {
  return {
    name: field,
    value: form[field],
  };
};

export const createFieldsFromBookingFormFields = (form: InviteGuestForm) => {
  const fields = [];
  if (form.firstName) fields.push(createField(FIELD_FIRST_NAME, form));
  if (form.lastName) fields.push(createField(FIELD_LAST_NAME, form));
  if (form.email) fields.push(createField(FIELD_EMAIL, form));
  if (form.phone) fields.push(createField(FIELD_PHONE, form));
  if (form.gender) fields.push(createField(FIELD_GENDER, form));
  if (form.nationality) fields.push(createField(FIELD_NATIONALITY, form));
  if (form.birth) fields.push(createField(FIELD_BIRTH, form));

  return fields as FormField[];
};
